import Image_Default from "../../images/man.png";
import { useState,useEffect } from "react";
import {connect} from "react-redux";
import { getRoom,getSecondUser,getRoomMessages } from "../../redux/actions/actions.js";
import { useParams } from "react-router-dom";

const Messages_Room = (props) => {
    const {room_id,user_one,user_two} = props;
    const [secondUser,setSecondUser] = useState([]);
    const [message,setMessage] = useState("");
    const [lastDate,setLastDate] = useState("");
    const params = useParams();

    useEffect(() => {
        try {
            if (user_one == params.id) {
                getUser(user_two)
            } else {
                getUser(user_one)
            };
        } catch (error) {
            console.log(error);
        }
    },[]);

    useEffect(() => {
        getMessage(room_id);
    })

    const getUser = (id) => {
        fetch(`/user?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setSecondUser(data[0])
        })
        .catch(error => console.log(error))
    }
    const getMessage = (id) => {
        fetch(`/lastmessage?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setMessage(data[0].content);
            const fullDate = new Date(data[0].created_at);
            const dayDate = fullDate.toLocaleDateString("en-US",{
                day: "2-digit"
            });
            const monthDate = fullDate.toLocaleDateString("en-US",{
                month: "2-digit"
            });
            setLastDate(`${dayDate}.${monthDate}`);
        })
        .catch(error => console.log(error))
    }
    const handleClick = (e) => {
        props.onGetRoom(user_one,user_two);
        if (user_one == params.id) {
            props.onGetSecondUser(user_two);
        } else {
            props.onGetSecondUser(user_one);
        };
        props.onGetRoomMessages(room_id);
    }

    return(
        <div onClick={handleClick} className={`messages_room background_change_hover background_change_hover_${props.color_background}`}>
            <img src={Image_Default} alt="User" className="messages_room_user_image" />
            <div className={`messages_room_main main_content_section_${props.color_background}`}>
                <div className="message_room_middle">
                    <div className="messages_room_userinfo">{secondUser.firstName} {secondUser.lastName}</div>
                    <div className={`messages_room_content messages_room_content_${props.color_background}`}>{message || "Start messaging..."}</div>
                </div>
                <div className={`messages_room_lastdate messages_room_content_${props.color_background}`}>{lastDate}</div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        second_user: state.getSecondUser.second_user,
        room: state.getRoom.room,
        room_messages: state.getRoomMessages.room_messages
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetRoom: (user_one,user_two) => dispatch(getRoom(user_one,user_two)),
        onGetSecondUser: (id) => dispatch(getSecondUser(id)),
        onGetRoomMessages: (id) => dispatch(getRoomMessages(id))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Messages_Room);